<template>
  <div class="contact">
    <div class="contact-container">
      <div class="contact-info">
        <h1>Lass uns zusammen arbeiten!</h1>
        <p>Kontaktiere mich für Kooperationen, Buchungen oder Anfragen</p>

      <form 
        class="contact-form" 
        action="https://formspree.io/f/mldjwjyv" 
        method="POST"
        @submit.prevent="handleSubmit"
      >
        <div class="form-group">
          <label for="name">Name</label>
          <input 
            type="text" 
            id="name" 
            name="name"
            v-model="formData.name"
            :class="{ 'error': errors.name }"
            required
          >
          <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
        </div>

        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="email" 
            id="email" 
            name="email"
            v-model="formData.email"
            :class="{ 'error': errors.email }"
            required
          >
          <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
        </div>

        <div class="form-group">
          <label for="subject">Betreff</label>
          <input 
            id="subject" 
            name="subject"
            v-model="formData.subject"
            :class="{ 'error': errors.subject }"
            required
          >
          <span class="error-message" v-if="errors.subject">{{ errors.subject }}</span>
        </div>

        <div class="form-group">
          <label for="message">Nachricht</label>
          <textarea 
            id="message" 
            name="message"
            v-model="formData.message"
            :class="{ 'error': errors.message }"
            required
          ></textarea>
          <span class="error-message" v-if="errors.message">{{ errors.message }}</span>
        </div>

        <button type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? 'Nachricht unterwegs...' : 'Nachricht Senden' }}
        </button>

        <div class="success-message" v-if="submitSuccess">
          Vielen Dank! Deine E-Mail wurde erfolgreich gesendet.
        </div>

        <div class="error-message global" v-if="submitError">
          Ein Fehler ist aufgetreten. Bitte versuche es erneut.
        </div>
      </form>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      errors: {},
      isSubmitting: false,
      submitSuccess: false,
      submitError: false
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      
      if (!this.formData.name.trim()) {
        this.errors.name = 'Name ist erforderlich'
      }
      
      if (!this.formData.email.trim()) {
        this.errors.email = 'Email ist erforderlich'
      } else if (!this.validateEmail(this.formData.email)) {
        this.errors.email = 'Bitte geben Sie eine gültige Email-Adresse ein'
      }
      
      if (!this.formData.subject.trim()) {
        this.errors.subject = 'Betreff ist erforderlich'
      }

      if (!this.formData.message.trim()) {
        this.errors.message = 'Nachricht ist erforderlich'
      }
      
      return Object.keys(this.errors).length === 0
    },
    
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    
    async handleSubmit(e) {
      if (!this.validateForm()) return
      
      this.isSubmitting = true
      this.submitError = false
      
      try {
        const form = e.target
        const formData = new FormData(form)
        
        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })

        if (response.ok) {
          this.submitSuccess = true
          this.formData = {
            name: '',
            email: '',
            subject: '',
            message: ''
          }
          
          setTimeout(() => {
            this.submitSuccess = false
          }, 5000)
        } else {
          throw new Error('Network response was not ok')
        }
      } catch (error) {
        console.error('Error:', error)
        this.submitError = true
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.contact {
  min-height: calc(90vh - 80px);
  padding: 2rem 2rem 4rem 2rem;
}

.contact-container {
  max-width: 800px;
  width: 100%;
  margin: 4rem auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
}

.contact-info {
  padding: 2rem;
}

.contact-info h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--accent);
}

.contact-info p {
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

.contact-details {
  margin-top: 3rem;
}

.detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  color: var(--text-secondary);
}

.detail-item i {
  margin-right: 1rem;
  color: var(--accent);
}

.contact-form {
  background-color: #1c1c1c;
  padding: 2rem;
  border-radius: 8px;
  position: relative;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}

input,
select,
textarea {
  width: 100%;
  padding: 0.8rem;
  background-color: #1c1c1c;
  border: 1px solid #333;
  border-radius: 4px;
  color: var(--text-primary);
  font-family: inherit;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--accent);
}

textarea {
  height: 150px;
  resize: vertical;
}

button {
  width: 100%;
  padding: 1rem;
  background-color: var(--accent);
  color: var(--text-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: opacity 0.3s ease;
}

button:hover {
  opacity: 0.9;
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error {
  border-color: #ff4444 !important;
}

.error-message {
  color: #ff4444;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}

.success-message {
  position: absolute;
  bottom: -60px;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #28a745;
  color: white;
  padding: 1rem;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .contact {
    padding: 1rem 1rem 2rem 1rem;
  }

  .contact-container {
    margin: 2rem auto 0;
    gap: 2rem;
  }
  
  .contact-info {
    text-align: center;
    padding: 1rem;
  }
  
  .detail-item {
    justify-content: center;
  }
}
</style>